/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContactUsRequestDto } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Contactus<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * @description 로그인 필수
	 *
	 * @tags /contactus
	 * @name DoPostContactUsPremium
	 * @summary 문의하기 프리미엄
	 * @request POST:/contactus/premium
	 * @secure
	 * @response `200` `string` OK
	 * @response `400` `string` 입력 데이터 확인
	 * @response `500` `string` 서버 오류
	 */
	doPostContactUsPremium = (data: ContactUsRequestDto, params: RequestParams = {}) =>
		this.http.request<string, string>({
			path: `/contactus/premium`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * @description 비 로그인, 로그인때문에 2개로 나눔
	 *
	 * @tags /contactus
	 * @name DoPostContactUsNormal
	 * @summary 문의하기 일반
	 * @request POST:/contactus/normal
	 * @secure
	 * @response `200` `string` OK
	 * @response `400` `string` 입력 데이터 확인
	 * @response `500` `string` 서버 오류
	 */
	doPostContactUsNormal = (data: ContactUsRequestDto, params: RequestParams = {}) =>
		this.http.request<string, string>({
			path: `/contactus/normal`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * @description 로그인 필수
	 *
	 * @tags /contactus
	 * @name DoPostContactUsMakeApp
	 * @summary 문의하기 앱추가 (추가: 2023.08)
	 * @request POST:/contactus/makeApp
	 * @secure
	 * @response `200` `string` OK
	 * @response `400` `string` 입력 데이터 확인
	 * @response `500` `string` 서버 오류
	 */
	doPostContactUsMakeApp = (data: ContactUsRequestDto, params: RequestParams = {}) =>
		this.http.request<string, string>({
			path: `/contactus/makeApp`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
}
